import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/ui/components';
import { DateFormatter } from '@repo/ui/date-formatter';
import { ChevronDown } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib/utils';
import { ChangeGroup } from './history-change-group.tsx';
import { EventRow } from './history-event-row.tsx';
import { HistoryTableHeader } from './history-table-header.tsx';
import type { HistoryDay } from '../history-utils/types.ts';
export const HistoryDaySection = t0 => {
  const $ = _c(26);
  const {
    day,
    onToggle,
    open
  } = t0;
  const panelId = `history-day-${day.id}`;
  let t1;
  if ($[0] !== day.date) {
    t1 = <DateFormatter date={day.date} kind="day-heading" data-sentry-element="DateFormatter" data-sentry-source-file="history-day-section.tsx" />;
    $[0] = day.date;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !open && "-rotate-90";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("size-5 transition-transform", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <ChevronDown aria-hidden="true" className={t3} data-sentry-element="ChevronDown" data-sentry-source-file="history-day-section.tsx" />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onToggle || $[7] !== open || $[8] !== panelId || $[9] !== t1 || $[10] !== t4) {
    t5 = <div className="px-3 py-3 @xl/history:px-4"><Button aria-controls={panelId} aria-expanded={open} className="h-auto justify-start gap-2 rounded-none bg-transparent p-0 text-lg leading-none font-bold" onClick={onToggle} variant="ghost-transparent" data-sentry-element="Button" data-sentry-source-file="history-day-section.tsx">{t1}{t4}</Button></div>;
    $[6] = onToggle;
    $[7] = open;
    $[8] = panelId;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = !open && "hidden";
  let t7;
  if ($[12] !== t6) {
    t7 = cn("mx-3 overflow-hidden rounded-md border @xl/history:mx-4", t6);
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <HistoryTableHeader data-sentry-element="HistoryTableHeader" data-sentry-source-file="history-day-section.tsx" />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== day.items) {
    t9 = day.items.map(_temp);
    $[15] = day.items;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t9) {
    t10 = <div className="divide-y">{t9}</div>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== panelId || $[20] !== t10 || $[21] !== t7) {
    t11 = <div className={t7} id={panelId}>{t8}{t10}</div>;
    $[19] = panelId;
    $[20] = t10;
    $[21] = t7;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t5) {
    t12 = <section data-sentry-component="HistoryDaySection" data-sentry-source-file="history-day-section.tsx">{t5}{t11}</section>;
    $[23] = t11;
    $[24] = t5;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};
function _temp(item) {
  return item.type === "changes" ? <ChangeGroup group={item} key={item.id} /> : <EventRow item={item} key={item.id} />;
}